import script from "./InventoryView.vue?vue&type=script&lang=ts&setup=true"
export * from "./InventoryView.vue?vue&type=script&lang=ts&setup=true"

import "./InventoryView.vue?vue&type=style&index=0&id=664e4edc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-664e4edc"]])

export default __exports__